import React from 'react';
import { fromMarkdown } from '@lib/utils';
import Image from 'next/image';
import { PostcodeSearch } from '@components/Molecules/PostcodeSearch';
import {
  Background,
  ContentSection,
  MobileImage,
  StyledActionsSection,
  StyledPostcodeSearch,
} from '@factories/RowFactory/components/HeroBackgroundImage/styled/StyledHeroBackgroundImage';
import HeroBackgroundImageT from '@factories/RowFactory/components/HeroBackgroundImage/types';
import { Cta } from '@components/Molecules';

export const HeroBackgroundImage = ({
  title,
  description,
  mobileImage,
  backgroundImage,
  display,
  showPostcodeChecker,
  actions,
}: HeroBackgroundImageT) => {
  if (!display) return null;

  return (
    <Background backgroundImage={backgroundImage.url as string}>
      <div className="container">
        <ContentSection>
          <h1>{title}</h1>
          {fromMarkdown({ text: description, isHeading: false })}
          {showPostcodeChecker !== false && (
            <StyledPostcodeSearch>
              <PostcodeSearch isStandalone={false} withBorder={false} />
            </StyledPostcodeSearch>
          )}
          {actions && actions?.length > 0 && (
            <StyledActionsSection>
              {actions?.map((action, index) => (
                <Cta
                  key={`hero-background-image-cta-${index}`}
                  display={action.display}
                  link={action.link}
                  label={action.label}
                  buttonType={action.buttonType}
                  event={action.event}
                />
              ))}
            </StyledActionsSection>
          )}
          {mobileImage && (
            <MobileImage>
              <Image
                src={mobileImage.url as string}
                alt={mobileImage.alternativeText || ''}
                width={425}
                height={400}
                objectFit="contain"
              />
            </MobileImage>
          )}
        </ContentSection>
      </div>
    </Background>
  );
};

export default HeroBackgroundImage;
